export default __webpack_public_path__ + "static/media/butcher10.3dace723.png";